// @flow
import React from "react";
import type { IconProps } from "./";

export default function Info({
  fill = "currentColor",
  width = "18px",
  ...props
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      width={width}
      fill={fill}
      fillRule="evenodd"
      {...props}
    >
      <path
        d="M942.01,299.952a8.055,8.055,0,1,0,8.055,8.055A8.056,8.056,0,0,0,942.01,299.952Zm-1,4.038h2.006v1.975h-2.006V303.99Zm2.978,7.97H940v-1h1v-2.95h-1v-1h3.01v3.953h0.972v1Z"
        transform="translate(-933.016 -299)"
      />
    </svg>
  );
}

export const InfoTour = ({
  fill = "currentColor",
  width = "30px",
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    width={width}
    fill={fill}
    {...props}
  >
    <path d="M0,30V15A15,15,0,1,1,15,30ZM3.8,15A11.2,11.2,0,1,0,15,3.8,11.217,11.217,0,0,0,3.8,15Z" />
    <g transform="translate(12.545 7.965)">
      <g transform="translate(0.447)">
        <circle cx="1.782" cy="1.782" r="1.782" />
      </g>
      <g transform="translate(0 5.253)">
        <path
          d="M209.81,224.716H204.9v-2.382h.9v-4.053h-.888V215.9h4v6.435h.9Z"
          transform="translate(-204.9 -215.9)"
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/Info.js